<template>
  <div class="merchant-wrapper">
    <template v-if="theme === 'swiper'">
      <swiper class="merchant-lists-container" v-if="merchants && merchants.length > 0" :class="theme"
        ref="merchant-swiper" :options="options">
        <swiper-slide class="grid__item-merchant scroll-up-to" v-for="(merchant, index) in merchants" :key="index">
          <router-link :to="{
            path: `/merchant/${merchant.id}/cases`,
          }">
            <div class="item__wrapper">
              <div class="item__cover">
                <div class="cover__logo">
                  <img :src="merchant.title_picture_url
                    ? merchant.title_picture_url
                    : merchant.logo_picture_url | parseImage
                    " alt="" class="lazyload" />
                </div>
              </div>
              <div class="item__info">
                <div class="info__title">{{ merchant.name }}</div>
                <div class="info__type">
                  <div class="type__child">
                    <p class="type__text">
                      {{
                        merchant.type
                        ? merchant.type === 1
                          ? "厂家直营店"
                          : "认证经销商"
                        : "厂家直营店"
                      }}
                    </p>
                    <i class="type__icon icon" :class="{
                          'icon-shop-short': merchant.type && merchant.type === 1,
                          'icon-business-short': merchant.type && merchant.type === 2,
                        }"></i>
                  </div>
                  <div v-if="merchant && merchant.type === 1 && merchant.sign > 0" class="sign__text">
                    <sign :sign="merchant.sign"></sign>
                  </div>
                </div>
                <div class="info__scope">{{ merchant.prov_name }}</div>
              </div>
            </div>
          </router-link>
        </swiper-slide>
      </swiper>
    </template>
    <template v-else>
      <div class="merchant-lists-container" v-if="merchants && merchants.length > 0" :class="theme">
        <router-link tag="div" class="grid__item-merchant scroll-up-to" v-for="(merchant, index) in merchants"
          :key="index" :to="{
            path: `/merchant/${recommendStore ? merchant.recommend_store_id : merchant.id}`,
          }">
          <div class="item__wrapper">
            <div class="item__cover">
              <div class="cover__logo">
                <img :src="merchant.title_picture_url
                  ? merchant.title_picture_url
                  : merchant.logo_picture_url | parseImage
                  " alt="" class="lazyload" />
              </div>
            </div>
            <div class="item__info">
              <div class="info__title">
                {{ recommendStore ? merchant.store_name : merchant.name }}
              </div>
              <div class="info__type">
                <div class="type__child">
                  <p class="type__text">
                    {{
                      merchant.type
                      ? merchant.type === 1
                        ? "厂家直营店"
                        : "认证经销商"
                      : "厂家直营店"
                    }}
                  </p>
                  <i class="type__icon icon" :class="{
                        'icon-shop-short': merchant.type === 1,
                        'icon-business-short': merchant.type === 2,
                      }"></i>
                </div>
                <div v-if="merchant && merchant.type === 1 && merchant.sign > 0" class="sign__text">
                  <sign :sign="merchant.sign"></sign>
                </div>
              </div>
              <div class="info__grade">
                <el-rate class="type__rate" disabled :value="merchant.level"></el-rate>
              </div>

              <div class="info__scope" v-if="!recommendStore">
                {{ recommendStore ? merchant.mold_name : merchant.prov_name }}
              </div>
              <div class="info__scope" v-else>
                <el-button class="info__btn" size="mini" type="primary" @click.stop="onAdd(merchant)">添加到我的供应商</el-button>
              </div>
            </div>
          </div>
        </router-link>
        <!-- <div class="type__text"><a :href='"https://store.clzx.net/index.php?ctl=Join&met=jump&typ=e&token=xyStore&store_id="+merchant.id+"&user_id="+user_id'>进入店铺</a></div> -->
      </div>
      <Empty hint="没有找到相关信息" v-else></Empty>
      <Pagination :config="isShowPagination" v-if="isShowPagination && showLimit === 0 && merchants.length > 0"
        class="component-pagination"></Pagination>
    </template>
  </div>
</template>

<script>
import Pagination from "@/components/pagination.vue";
import Empty from "@/pages/common/empty.vue";
import localstorage from "@/assets/utils/localstorage";
import axios from "axios";
import { addSupplier } from "@/api/supplier";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapState } from "vuex";
import Sign from './_sign.vue'
export default {
  components: {
    Pagination,
    Swiper,
    SwiperSlide,
    Empty,
    Sign
  },
  props: {
    merchants: {
      type: Array,
      default: () => [],
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    showLimit: {
      type: Number,
      default: 0,
    },
    theme: {
      type: String,
      default: "big",
    },
    // 推荐商家 引入
    recommendStore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user_id: 0,
      options: {
        // autoplay: {
        //   delay: 2500,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        loop: true,
        slidesPerView: this.$isMobile ? 2 : 3,
        slidesPerGroup: this.$isMobile ? 2 : 3,
        init: false,
      },
    };
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info,
    ...mapState(["pageloading"]),
  }),
  watch: {
    pageloading: {
      handler(val) {
        if (!val) {
          const that = this;
          that.$nextTick(() => {
            if (that.$refs["merchant-swiper"]) {
              setTimeout(() => {
                that.$refs["merchant-swiper"].$swiper.init();
              }, 500);
            }
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getXyUrl();
  },
  methods: {
    getXyUrl: function () {
      this.cf_token = localstorage.get("TOKEN");
      axios({
        method: "get",
        url: "http://api.clzx.net/public/html/user/myInfo?access_token=" + this.cf_token,
      })
        .then((res) => {
          this.user_id = res.data.data.id;
        })
        .catch((err) => { });
    },
    onAdd(info) {
      this.loading = true;
      this.api = addSupplier;
      let form = {
        company: info.store_name,
        cat_name: info.mold_name,
        contacts: info.contact || "",
        phone: info.phone || "",
        store_id: info.recommend_store_id,
        user_id: this.userInfo.id,
      };
      console.log(info, "info");
      // return
      this.api(form)
        .then((res) => {
          this.loading = false;
          this.addVisible = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.init();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.merchant-wrapper {
  .info__grade {
    margin-top: 0.58125vw;
  }

  .info__scope {
    margin-top: 0 !important;
  }

  .el-rate__icon {
    margin-right: 0 !important;
  }

  .item__info {
    position: relative;

    .info__btn {
      color: #000;
    }
  }
}
</style>
